module.exports = __webpack_public_path__ + "static/media/navigator.d84e6cc7.png";